/**
 * Fetch currency information. Returns 'CFA' on errors.
 */
export const fetchCurrency = async (signal = null) => {
  try {
    const response = await fetch(`/api/currency`, { signal });
    if (!response.ok) throw new Error("Currency request failed");
    const data = await response.json();
    return data?.currencies?.[0]?.currency || "CFA";
  } catch (error) {
    if (error?.name !== "AbortError") console.error(error);
    return "CFA";
  }
};

